export default function IconCircleMinus(props: {
  size?: number;
  strokeWidth?: number;
  className?: string;
}) {
  const { size = 24, strokeWidth = 1.4, className } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      className={className}
    >
      <g
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={strokeWidth}
      >
        <circle cx="12" cy="12" r="9" />
        <path d="M8 12h8" />
      </g>
    </svg>
  );
}
